
import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { ReactNode } from "react";
import { isAdminEmail } from "@/constants/admin";

interface AdminRouteProps {
  children: ReactNode;
}

export const AdminRoute = ({ children }: AdminRouteProps) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="p-8 text-center">Vérification des permissions...</div>;
  }

  // Si l'utilisateur n'est pas connecté, rediriger vers la page de connexion
  if (!user) {
    console.log('User not logged in, redirecting to auth');
    return <Navigate to="/auth" />;
  }

  // Accès uniquement pour babotesto@gmail.com
  if (!isAdminEmail(user.email)) {
    console.log('User is not admin, redirecting to home');
    return <Navigate to="/" />;
  }

  console.log('User is admin, rendering admin content');
  return <>{children}</>;
};
